import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Globe, ChevronDown } from 'lucide-react';

const MERCOR_PURPLE = '#5B3DC5';

const TopHeaderBar = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div
      className="w-full h-[48px] px-4 sm:px-6 flex items-center justify-between z-30 shrink-0"
      style={{
        backgroundColor: '#FFFFFF',
        borderBottom: '1px solid #E5E7EB',
      }}
    >
      {/* Left: Get Instant Work Offers */}
      <div className="flex items-center gap-1.5">
        <span className="text-[13px] text-gray-500">Get</span>
        <span className="text-[13px] font-semibold text-gray-800">Instant Work Offers</span>
        <svg className="w-3.5 h-3.5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      </div>

      {/* Center: Progress Stepper */}
      <div className="hidden sm:flex items-center gap-0">
        {/* Step 1 - Resume (active) */}
        <div className="flex items-center gap-1.5">
          <span className="w-[20px] h-[20px] rounded-full text-[10px] font-bold flex items-center justify-center text-white" style={{ backgroundColor: MERCOR_PURPLE }}>1</span>
          <span className="text-[13px] font-medium text-gray-800">Resume</span>
        </div>
        {/* Connector */}
        <div className="w-[60px] h-[1px] mx-3" style={{ backgroundColor: '#D1D5DB' }} />
        {/* Step 2 - Location */}
        <div className="flex items-center gap-1.5">
          <span className="w-[20px] h-[20px] rounded-full text-[10px] font-bold flex items-center justify-center text-gray-400" style={{ border: '1.5px solid #D1D5DB' }}>2</span>
          <span className="text-[13px] font-medium text-gray-400">Location</span>
        </div>
        {/* Connector */}
        <div className="w-[60px] h-[1px] mx-3" style={{ backgroundColor: '#D1D5DB' }} />
        {/* Step 3 - Assessment */}
        <div className="flex items-center gap-1.5">
          <span className="w-[20px] h-[20px] rounded-full text-[10px] font-bold flex items-center justify-center text-gray-400" style={{ border: '1.5px solid #D1D5DB' }}>3</span>
          <span className="text-[13px] font-medium text-gray-400">Assessment</span>
        </div>
      </div>

      {/* Right: Take Assessment + Language */}
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate('/explore')}
          className="hidden sm:block px-4 py-[6px] text-[13px] font-medium rounded-md transition-colors"
          style={{
            color: '#1A1A1A',
            border: '1px solid #E5E7EB',
            backgroundColor: '#FFFFFF',
          }}
          onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#F9FAFB'; }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#FFFFFF'; }}
        >
          Take Assessment
        </button>

        {/* Language selector */}
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setOpen(!open)}
            className="flex items-center gap-1.5 px-2.5 py-[5px] rounded-md text-[12px] font-medium transition-colors"
            style={{
              color: '#4B5563',
              backgroundColor: open ? '#F3F4F6' : 'transparent',
              border: '1px solid #E5E7EB',
            }}
          >
            <Globe className="w-3.5 h-3.5" />
            EN
            <ChevronDown className="w-3 h-3" />
          </button>
          {open && (
            <div
              className="absolute right-0 top-full mt-1 rounded-lg shadow-lg py-1 min-w-[120px] bg-white"
              style={{ border: '1px solid #E5E7EB' }}
            >
              {['English', 'Spanish', 'French'].map(lang => (
                <button
                  key={lang}
                  className="block w-full px-3 py-2 text-left text-xs text-gray-700 hover:bg-gray-50 transition-colors"
                  onClick={() => setOpen(false)}
                >
                  {lang}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopHeaderBar;
